import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../pages/layout/page";
import Home from "../pages/home/page";
import Renwu from "../pages/renwu/page";
import Zixun from "../pages/zixun/page";
import ZixunDetail from "../pages/zixun/detail";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "renwu", element: <Renwu /> },
      { path: "zixun", element: <Zixun /> },
      { path: "zixun/:id", element: <ZixunDetail /> },
      { path: "about", element: <About /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;